// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"35751b81","455":"5f67a309","946":"c41f3ec5"}[chunkId] + ".chunk.js";
};